import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type OCWDeepLinkRequest = {
  appointment_id: number;
};

export const useGetOCWVehicleStatus = ({ appointment_id }: OCWDeepLinkRequest, enabled = true) => {
  const canListOCWVehicleStatus = useCan("list", "pon-ocw-vehicle-status");

  return useTypedQuery({
    queryKey: AppointmentDetailsKeys.ponOCWVehicleStatus,
    queryFn: async () =>
      (await ApiInstance.post(AppointmentDetailsKeys.ponOCWVehicleStatus.endpoint, { appointment_id }, AppointmentDetailsKeys.ponOCWVehicleStatus.baseUrl))?.data ?? null,
    enabled: canListOCWVehicleStatus && enabled && appointment_id > 0
  });
};

export const useGetEnrollmentLink = ({ appointment_id }: OCWDeepLinkRequest) =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.ponOCWEnrollmentLink,
    queryFn: async () =>
      (await ApiInstance.post(AppointmentDetailsKeys.ponOCWEnrollmentLink.endpoint, { appointment_id }, AppointmentDetailsKeys.ponOCWEnrollmentLink.baseUrl))?.data
        ?.url ?? null,
    enabled: false
  });

export const useGetServiceLink = ({ appointment_id }: OCWDeepLinkRequest) =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.ponOCWServiceLink,
    queryFn: async () =>
      (await ApiInstance.post(AppointmentDetailsKeys.ponOCWServiceLink.endpoint, { appointment_id }, AppointmentDetailsKeys.ponOCWServiceLink.baseUrl))?.data?.url ??
      null,
    enabled: false
  });
